import { LoaderFunction, redirect } from "react-router-dom";
import HttpService from "@core/services/http/http.service";
import { RoutePath } from "@app/constants";

export const isAuthenticated: LoaderFunction = () => {
  const token = HttpService.getAccessToken();

  if (!token) {
    return redirect(RoutePath.HOME);
  }

  return true;
};
